import { render, staticRenderFns } from "./QA.vue?vue&type=template&id=e13fa350&scoped=true"
import script from "./QA.vue?vue&type=script&lang=ts"
export * from "./QA.vue?vue&type=script&lang=ts"
import style0 from "./QA.vue?vue&type=style&index=0&id=e13fa350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13fa350",
  null
  
)

export default component.exports